import { useEffect, useState, useRef, useCallback } from "react"
import { useLocation, useNavigationType } from 'react-router-dom'
import { Loading, SectionHeading, TableCustom } from "../../components/common"
import { useNavigateWithFilters } from "../../components/hooks"
import { ServerRequest } from "../../utils/apiweb"
import { ALERT_TYPE, OPERATION_MODE, REQUEST_METHOD, ShowToastMessage } from '@laramie/ui';
import { APIS } from "../../config/apis"
import { MESSAGE_MODALS } from "../../context/custom/MessageModalContext"
import { useManagedContext } from "../../components/hooks"
import { PERMISSIONS } from "../../consts/permissions"

const TablasDefinicionView = (props) => {

    const location = useLocation()
    const navigationType = useNavigationType()
    
    const initialFilters = (navigationType === 'PUSH' && location.state?.filters) ? location.state.filters : null;

    const [tablas, setTablas] = useState([])
    const [loading, setLoading] = useState(false)
    const [restoredPageIndex] = useState(() => initialFilters?.pageIndex ?? 0)
    const [restoredGlobalFilter] = useState(() => initialFilters?.globalFilter)

    const tableRef = useRef()
    const { showMessageModal } = useManagedContext()

    const getCurrentFilters = useCallback(() => {
        const currentPageIndex = tableRef?.current?.pageIndex ?? 0;
        const currentGlobalFilter = tableRef?.current?.globalFilter;
        return { 
            formValues: { _placeholder: true },
            selectedValues: {},
            pageIndex: currentPageIndex,
            globalFilter: currentGlobalFilter 
        };
    }, [tableRef]);
    const navigateWithFilters = useNavigateWithFilters(getCurrentFilters);
    
    const onNoSuccess = res => res.json()
        .then(err => ShowToastMessage(ALERT_TYPE.ALERT_ERROR, err.message))
        .catch(err => ShowToastMessage(ALERT_TYPE.ALERT_ERROR, 'Error procesando respuesta: ' + err)
        .finally(() => setLoading(false))
    )

    const onError = err => {
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, 'Error procesando solicitud: ' + err.message)
        setLoading(false)
    }

    useEffect(() => {
        SearchTablasDefinicion();
    }, [])

    const avmr = {
        onAdd: () => {
            navigateWithFilters('/tabla-definicion/' + OPERATION_MODE.NEW);
        },
        onView: ({ id }) => {
            navigateWithFilters('/tabla-definicion/' + `${OPERATION_MODE.VIEW}/${id}`);
        },
        onModify: ({ id }) => {
            navigateWithFilters('/tabla-definicion/' + `${OPERATION_MODE.EDIT}/${id}`);
        },
        onRemove: ({ id }) => {
            const tabla = tablas.find(x => x.id === id);
            showMessageModal({
                ...MESSAGE_MODALS.BORRAR,
                message: `¿Está seguro de borrar el registro ${tabla.nombre}?`, 
                onConfirm: () => confirmRemoveId(id),
            })
        }
    }

    const confirmRemoveId = (id) => {
        setLoading(true)

        const onSuccessRemove = (response) => {
            response.json()
            .then((id) => {
                SearchTablasDefinicion()
                ShowToastMessage(ALERT_TYPE.ALERT_SUCCESS, 'Tabla Definición borrada')
            })
            .catch(onNoSuccess)
            .finally(() => setLoading(false))
        };        

        ServerRequest(
            REQUEST_METHOD.DELETE,
            null,
            true,
            APIS.URLS.TABLAS,
            `/${id}`,
            null,
            onSuccessRemove,
            onNoSuccess,
            onError,
        )
    }

    function SearchTablasDefinicion() {

        const onSuccessFind = (response) => {
            response.json()
            .then(data => {
                setTablas(data)
            })
            .catch(onNoSuccess)
            .finally(() => setLoading(false))
        }

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.TABLAS,
            null,
            null,
            onSuccessFind,
            onNoSuccess,
            onError,
        )
    }

    return (
        <div>
            <Loading visible={loading} />

            <SectionHeading titles={[{ title: 'Entidades' }, { title: 'Definición de tablas' }]} />

            <section className='section-accordion'>
                <div className="m-top-20">
                    <TableCustom
                        ref={tableRef}
                        className={'TableCustomBase'}
                        data={tablas}
                        columns={[
                            { Header: 'Nombre', accessor: 'nombre', width: '25%' },
                            { Header: 'Código', accessor: 'codigo', width: '25%', },
                            { Header: 'Descripción', accessor: 'descripcion', width: '50%', },
                        ]}
                        avmr={avmr}
                        editCode={PERMISSIONS.TABLA_DEFINICION_EDIT}
                        restoredPageIndex={restoredPageIndex}
                        defaultGlobalFilter={restoredGlobalFilter}
                    />
                </div>
            </section> 

        </div>
    )
}

export default TablasDefinicionView
